import { useField } from '@mantine/form'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import { useMemo, useState } from 'react'

import { PAGINATION_LIMIT } from 'src/v2/commons/config'
import { useAppSelector } from 'src/v2/store/hooks'

const usePaginate = () => {
  const [page, setPage] = useState(0)

  const { id: orgId } = useAppSelector(selectCurrentOrganization)

  const paginationLimitField = useField({
    initialValue: PAGINATION_LIMIT.toString(),
    onValueChange: (value: string) => {
      setPage(0)
      return value
    },
  })

  const organizationId = useMemo(() => {
    setPage(0)
    return orgId
  }, [orgId])

  const handlePaginate = (pageNumber: number) => {
    setPage(pageNumber - 1)
  }

  return {
    handlePaginate,
    paginationLimitField,
    tablePage: page + 1,
    organizationId,
    page,
  }
}

export default usePaginate
